/* Copyright Information: Created by BuyGroup */
const Roles = {
    ADMIN: "ADMIN",
    SUPPLIER: "SUPPLIER",
    CUSTOMER:"CUSTOMER"
  };
  export default Roles;
  /* Copyright Information: Created by BuyGroup */
